import {sortBy} from 'lodash';
import {useMemo} from 'react';
import { useSelector } from 'react-redux';

export const selectUsers = state => state.users;

export function useUsers({filter, sortBy: sortFunction} = {}) {
    const users = Object.values(useSelector(selectUsers));

    return useMemo(() => {
        let result = users;

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [users]);
}
